import React, { useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { languageContext } from 'contexts/language_context/LanguageContext';

const MileageDisplay = ({ mileage }) => {
    const { weblanguage } = useContext(languageContext);
    const isArabic = weblanguage === 'ar';

    const formatNumber = (num) => {
        if (num === null || num === undefined) return 'N/A';
        return num.toLocaleString('en-US', { maximumFractionDigits: 0 });
    };

    const toArabicNumerals = (str) => {
        return str.replace(/[0-9]/g, d => "٠١٢٣٤٥٦٧٨٩"[d]).replace('.', ',');
    };

    const displayMileage = () => {
        const formatted = formatNumber(mileage);
        if (formatted === 'N/A') return 'N/A';
        return isArabic ? toArabicNumerals(formatted) : formatted;
    };

    return (
        <span className="fw-bold fs-7 text-nowrap">
            {displayMileage()} {isArabic ? 'كم' : 'km'}
        </span>
    );
};

export default MileageDisplay;
